import { Box, BoxProps, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { LayoutAnimation, Platform, UIManager } from 'react-native'
import { Routes } from '../../nav/routes'
import { ChatbotAwareness } from '../../screens/Support/ChatbotAwareness'
import { getString } from '../../util/languageStrings'
import { Colors, isOsMobile, logEvent } from '../../util/util'
import { SvgImage } from '../SvgImage'

export const ChatbotButton = ({ showChatbotAwareness, shrink = false }: any) => {
  const [expandBtn, setExpandBtn] = useState(false)
  const [showModal, setShowModal] = useState(showChatbotAwareness)
  const navigation = useNavigation()

  useEffect(() => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
    setExpandBtn(shrink)
  }, [expandBtn, shrink])

  const navigateToChatbot = () => {
    logEvent('btn_press', 'Raise Query')
    setShowModal(false)
    navigation?.navigate(Routes.CHATBOT as never, { isAfterLogin: true } as never)
  }

  if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
    UIManager.setLayoutAnimationEnabledExperimental(true)
  }

  if (!isOsMobile()) {
    return <></>
  }

  return (
    <>
      <ChatbotAwareness show={showModal} onCancel={() => setShowModal(false)} onPress={navigateToChatbot} />
      <ModBox
        show={!showModal}
        position={'absolute'}
        bottom={40}
        zIndex={11}
        right={20}
        borderRadius={45}
        bg={Colors.PRIMARY}
        justify="center"
        underlayColor={'SECONDARY' as ColorOptions}
        onPress={navigateToChatbot}
        testID="navigateToChatbot"
        overflow={'hidden'}
        align="center">
        <Box
          flexDirection={'row'}
          justify="center"
          underlayColor={'SECONDARY' as ColorOptions}
          onPress={() => {
            navigateToChatbot()
          }}
          overflow={'hidden'}
          align="center">
          <Box flexDirection={'row'} justify="center" align="center" p={12}>
            <Box justify="center" align="center">
              <SvgImage imageName="ChatIcon" />
            </Box>
            <Box {...({ width: shrink ? 0 : 104 } as BoxProps)}>
              <Spacer size={5} direction="horizontal" />
              <ModBox opacity={shrink ? 0 : 1} justify="center" align="center">
                <Text fontFamily={'JioType-Bold'} numberOfLines={1} fontSize={14} color="WHITE">
                  {getString(null, 'chatWithUs')}
                </Text>
              </ModBox>
            </Box>
          </Box>
        </Box>
      </ModBox>
    </>
  )
}
